import {LOAD_REPORT_REQUEST,LOAD_REPORT_SUCCESS,LOAD_REPORT_FAILURE,RUN_REPORT_REQUEST,RUN_REPORT_SUCCESS,RUN_REPORT_FAILURE,GET_PARAM_VALUES_REQUEST,GET_PARAM_VALUES_SUCCESS,GET_PARAM_VALUES_FAILURE, SET_FILTER_DATA} from '../actions/reportAction';


const initState = {
  loadingParams: null,
  paramRequestStatus: null,
  loadingResults:false,
  resultRequestStatus: null,
  loadingParamVals: null,
  reportMetaData:null,
  columns: [],
  filteredData: [],
  data: [],
  formData: []
}

export default function caseActionReducer(state = {
  ...initState
}, action) {
  switch (action.type) {
    case LOAD_REPORT_REQUEST:
      return {
        ...state,
        loadingParams: true,
        reportMetaData:null,
        columns: [],
        filteredData: [],
        data: []
      }
    case LOAD_REPORT_SUCCESS:
      return {
        ...state,
          loadingParams: false,
          reportMetaData: action.payload
      }
    case LOAD_REPORT_FAILURE:
      return {
        ...state,
        loadingParams: "failure",
      }
      case RUN_REPORT_REQUEST:
        return {
          ...state,
          loadingResults: true,
          formData: action.payload.formData,
          resultRequestStatus: "trying"
        }
      case RUN_REPORT_SUCCESS:
        return {
          ...state,
          loadingResults: false,
          resultRequestStatus: "success",
          columns: action.payload.columns,
          data: action.payload.data,
          filteredData: action.payload.data
        }
      case RUN_REPORT_FAILURE:
        return {
          ...state,
          resultRequestStatus: "failure",
          loadingResults: false
        }
      case GET_PARAM_VALUES_REQUEST:
        return {
          ...state,
          loadingParamVals: true,
        }
      case GET_PARAM_VALUES_SUCCESS:
        var index = -1;
        if(state.reportMetaData && state.reportMetaData.params){
          return {
            ...state,
            reportMetaData: {...state.reportMetaData,
                params: state.reportMetaData.params.map((param,i)=>{
                  if(param.name==action.payload.name){
                     return ({...param, choices: action.payload.choices})
                  }else {return {...param}}
                })

            },
            loadingParamVals: false,
          }
        }
        else {
          return {...state,
             loadingParamVals: false}
        }
      case GET_PARAM_VALUES_FAILURE:
        return {
          ...state,
          loadingParamVals: false,
        }
       case SET_FILTER_DATA:
         return {
           ...state,
           filteredData: action.payload
         }

    default:
      return {
        ...state
      }
  }
}
